import { motion } from "framer-motion";
import { Candy, Puzzle, Users } from "lucide-react";

const chapters = [
  {
    num: "01",
    icon: Candy,
    title: "Candy for everyone",
    body: "Retro favourites, nostalgic classics, unique finds, and the latest trending candy. There’s always something new — and probably something you haven’t seen in years.",
    bg: "bg-[#FFD700]",
  },
  {
    num: "02",
    icon: Puzzle,
    title: "Toys, collectibles & fun finds",
    body: "From toys and plushies to collectibles, fidgets and surprise finds. Fun stuff for kids, collectors, and grown-ups who refuse to grow up.",
    bg: "bg-white",
  },
  {
    num: "03",
    icon: Users,
    title: "More than just a store",
    body: "We’re a small shop with new finds arriving all the time. Follow our Facebook community for new arrivals, special deals, giveaways and everything happening at the store.",
    bg: "bg-[#FF2A54]",
    dark: true,
    link: true,
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="border-b-2 border-[#0A0A0A] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl lg:text-6xl"
        >
          What we&rsquo;re <span className="text-[#FF2A54]">about</span>
        </motion.h2>

        <div className="mt-16 flex flex-col gap-10">
          {chapters.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.05 * i }}
              data-testid={`manifesto-chapter-${c.num}`}
              className={`hard-shadow hard-shadow-hover rounded-2xl border-2 border-[#0A0A0A] p-8 sm:p-12 ${c.bg} ${
                i % 2 === 1 ? "sm:ml-auto sm:max-w-3xl" : "sm:mr-auto sm:max-w-3xl"
              }`}
            >
              <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
                <span className={`font-display text-7xl font-black leading-none tracking-tighter sm:text-8xl ${c.dark ? "text-[#FFD700]" : "text-[#FF2A54]"}`}>
                  {c.num}
                </span>
                <div>
                  <h3 className={`flex items-center gap-3 font-display text-2xl font-bold tracking-tight sm:text-3xl ${c.dark ? "text-white" : "text-[#0A0A0A]"}`}>
                    <c.icon className="h-7 w-7" /> {c.title}
                  </h3>
                  <p className={`mt-3 text-base leading-relaxed sm:text-lg ${c.dark ? "text-white/90" : "text-[#4A4A4A]"}`}>
                    {c.body}
                  </p>
                  {c.link && (
                    <a
                      href="https://www.facebook.com/groups/1112257584339430"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="manifesto-facebook-link"
                      className="mt-4 inline-block font-display text-sm font-extrabold uppercase tracking-wide text-[#FFD700] underline decoration-white decoration-2 underline-offset-4 hover:text-white"
                    >
                      Join our Facebook community
                    </a>
                  )}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
